import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DeviceVersionComponent } from "../components/device/version/DeviceVersionComponent";
import { retrieveFirmwareVersionFromServer } from "../utils/retrieveFirmwareVersion";
import { RootState } from "../stores/store";

interface Props {};

const DeviceVersionPage = (props: Props) => {
  const dispatch = useDispatch();
  const currentConnectedDeviceId = useSelector(
    (state: RootState) => state.device.currentConnectedDeviceId
  );

  useEffect(() => {
    if (!currentConnectedDeviceId) return;
    retrieveFirmwareVersionFromServer(dispatch, currentConnectedDeviceId);
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <DeviceVersionComponent />
      </Grid>
    </Grid>
  );
};

export { DeviceVersionPage };
